/**
 * Función centralizada para limpiar la sesión del usuario
 * Limpia tanto sessionStorage como items específicos de localStorage
 * Esta función puede ser llamada desde cualquier lugar de la aplicación
 */
export const clearUserSession = () => {
  // Limpiar sessionStorage completo
  window.sessionStorage.clear();

  // Limpiar items específicos del localStorage
  window.localStorage.removeItem("tipohoras");
  window.localStorage.removeItem("tipoubicacionesfisica");
  window.localStorage.removeItem("tipoactividades");
  window.localStorage.removeItem("tipoubicacionesernage");
  window.localStorage.removeItem("contratoElegido");
  window.localStorage.removeItem("tipooperacion");
  window.localStorage.removeItem("periodo");
  window.localStorage.removeItem("contratoColaborador");
  window.localStorage.removeItem("centroCostoModal");
  window.localStorage.removeItem("contratos");
};

/**
 * Función completa de logout que limpia la sesión y redirige al login
 * Usar esta función cuando se necesite hacer logout desde fuera de componentes React
 */
export const performLogout = () => {
  clearUserSession();
  window.location.href = '/';
};
